module.exports = __webpack_public_path__ + "static/media/send.1e836dbb.svg";